import React from 'react';
// @ts-ignore
import { Table } from '@els/els-react--table';
// @ts-ignore
import { Loader } from '@els/els-react--loader';

import type { ISkillDetails } from '../../../../libs/utils/interfaces/ebpc-interface';
import EbpcSkillListRow from './Ebpc-Skill-List-Row';
import './ebpc-table.scss';

const EbpcSkillList = (props: any) => {
    const { skillList, id, isSorting, handleRedirectToSkillDetail } = props;
    const headers = [
        {
            value: 'skillName',
            label: 'Skill Name',
        },
        {
            value: 'dateUpdated',
            label: 'Date Updated',
        },
    ];

    const baseClassName = 'ebpc-skill-list-wrapper';
    return (
        <div id="skill-list" className={baseClassName}>
            <div className={`${baseClassName}__container`}>
                {isSorting ? (
                    <Loader isVisible isBlocking={false} />
                ) : (
                    <Table
                        id={id}
                        className={`${baseClassName}__container__skill-list`}
                        a11y={{
                            name: 'Table evidence based practice changes skill list',
                            description:
                                'Evidence based practice changes skill table list',
                            showDescription: false,
                        }}
                        data={skillList}
                        columns={headers}
                        renderDatum={
                            (data: any) =>
                                data.map(
                                    ({
                                        courseId,
                                        skillName,
                                        dateUpdated,
                                    }: ISkillDetails) => (
                                        <EbpcSkillListRow
                                            key={courseId}
                                            courseId={courseId}
                                            skillName={skillName}
                                            dateUpdated={dateUpdated}
                                            className={`${baseClassName}__container__skill-list`}
                                            handleRedirectToSkillDetail={
                                                handleRedirectToSkillDetail
                                            }
                                        />
                                    )
                                )
                            // eslint-disable-next-line react/jsx-curly-newline
                        }
                    />
                )}
            </div>
        </div>
    );
};
export default EbpcSkillList;
